import { Box, Container, Typography } from "@mui/material";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

export default function Partner() {
  const { t } = useTranslation();

  return (
    <Box
      component="section"
      sx={{
        py: { xs: 8, md: 10 },
        bgcolor: "#ffffff",
        borderTop: "1px solid #f1f5f9",
      }}
    >
      <Container maxWidth="xl">
        <Typography
          sx={{
            textAlign: "center",
            color: "#0069A7",
            fontWeight: 600,
            fontSize: {
              xs: "1.5rem",
              md: "1.875rem",
            },
            letterSpacing: "-0.02em",
            mb: 8,
          }}
        >
          {t("partner.title")}
        </Typography>

        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            alignItems: "center",
            gap: {
              xs: 8,
              md: 16,
            },
          }}
        >
          {/* Oracle */}
          <Box
            component={motion.div}
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            whileHover={{
              scale: 1.1,
              y: -4,
            }}
            sx={{
              cursor: "default",
            }}
          >
            <Box
              component="img"
              src="/Oracle-Logo.webp"
              alt="Oracle Partner"
              sx={{
                width: {
                  xs: 180,
                  md: 260,
                },
                height: "auto",
                display: "block",
              }}
            />
          </Box>

          {/* Google */}
          <Box
            component={motion.div}
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{
              duration: 0.5,
              delay: 0.2,
            }}
            whileHover={{
              scale: 1.1,
              y: -4,
            }}
            sx={{
              cursor: "default",
            }}
          >
            <Box
              component="img"
              src="/Google-Logo.webp"
              alt="Google Partner"
              sx={{
                width: {
                  xs: 180,
                  md: 260,
                },
                height: "auto",
                display: "block",
              }}
            />
          </Box>
        </Box>
      </Container>
    </Box>
  );
}